export default __webpack_public_path__ + "static/media/Pot1.fcd2e3bd.svg";